export const RenderProductCode = ({
	code,
	render,
}: {
	code: string;
	render: (src: string) => JSX.Element;
}) => {
	const _code = code.replace(/(-T.*)$/, '');
	return render(`Código: ${_code}`);
};
